// A-Z by name for the account and location pickers (case-insensitive, "Site 2" before "Site 10").
const collator = new Intl.Collator(undefined, { sensitivity: 'base', numeric: true });

export function sortByName(items = []) {
  return [...items].sort((a, b) => collator.compare(String(a?.name || a?.id || ''), String(b?.name || b?.id || '')));
}
